import { useEffect, useState } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import { useI18n } from '../../i18n/I18nProvider';
import { DashboardView } from './DashboardView';
import { createDashboardFetch, loadDashboard } from './dashboard.api';
import type { DashboardData } from './dashboard.api';

type ViewState =
  | { kind: 'loading' }
  | { kind: 'ready'; data: DashboardData }
  | { kind: 'error'; message: string };

export default function DashboardScreen(): JSX.Element {
  const { authorizedFetch } = useAuth();
  const { t } = useI18n();
  const [state, setState] = useState<ViewState>({ kind: 'loading' });

  useEffect(() => {
    let live = true;
    loadDashboard(createDashboardFetch(authorizedFetch))
      .then((data) => {
        if (live) setState({ kind: 'ready', data });
      })
      .catch((error: unknown) => {
        if (live) setState({ kind: 'error', message: error instanceof Error ? error.message : String(error) });
      });
    return () => {
      live = false;
    };
  }, [authorizedFetch]);

  if (state.kind === 'loading') {
    return (
      <section className="card" data-testid="dashboard-loading">
        <p className="muted">{t('dashboard.loading')}</p>
      </section>
    );
  }
  if (state.kind === 'error') {
    return (
      <section className="alert alert--danger" role="alert" data-testid="dashboard-error">
        {state.message}
      </section>
    );
  }
  return <DashboardView data={state.data} />;
}
